"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("./SessionPageLogo.css");

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = function _default(_ref) {
  var baseAddress = _ref.baseAddress,
      label = _ref.label;
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "session-page-logo",
    href: baseAddress
  }, label || "Link to Gradifi homepage");
};

exports.default = _default;